import { useRealtimeHandler } from "@/shared/realtime";

import { handleAnalysisDone } from "./handleAnalysisDone";
import { handleAnalysisFailed } from "./handleAnalysisFailed";
import { handleAnalysisProgress } from "./handleAnalysisProgress";

// Обработчики событий `analysis.*`, пока открыт экран разбора.
export const useAnalysisEvents = (): void => {
  useRealtimeHandler("analysis.progress", handleAnalysisProgress);
  useRealtimeHandler("analysis.done", handleAnalysisDone);
  useRealtimeHandler("analysis.failed", handleAnalysisFailed);
};
